import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

const YearNav = ({ content, activeIndex, changeNavHandle }) => {
    return (
        <div className={styles.yearNav}>
            {content.map((item, index) => {
                return (
                    <div
                        key={index}
                        onClick={() => {
                            changeNavHandle(index);
                        }}
                        className={`${styles.yearNavItem} ${activeIndex === index ? styles.active : ''}`}>
                        {item.year}
                    </div>
                );
            })}
        </div>
    );
};

YearNav.propTypes = {
    content: PropTypes.array,
    activeIndex: PropTypes.number,
    changeNavHandle: PropTypes.func,
};

export default errorBoundary(YearNav);
